import styled from "styled-components";

export const StyledReports = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export const StyledReportsContent = styled.div`
    padding: 40px;
    height: 100%;
`;